import { Injectable } from "@angular/core";
import { PurchaseService } from "./purchase.service";
import { firstValueFrom, Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { setPurchaseStateAction, optimimisticForceTrialEndedAction } from "./purchase-state";
import { Store } from "@ngrx/store";

@Injectable({
	providedIn: 'root'
})
export class PurchaseStateService {
	private refreshSubject = new Subject<void>();

	constructor(
		private readonly purchaseService: PurchaseService,
		private readonly store: Store
	) {
		this.refreshSubject.pipe(
			debounceTime(300) // 300ms debounce time
		).subscribe(() => this.performRefreshPurchaseState());
	}

	async refreshPurchaseState(): Promise<void> {
		this.refreshSubject.next();
	}

	private async performRefreshPurchaseState(): Promise<void> {
		const purchaseState = await firstValueFrom(this.purchaseService.getPurchaseDetails());
		this.store.dispatch(setPurchaseStateAction({ purchaseState }));
	}

	async optimimisticForceTrialEnded(): Promise<void> {
		this.store.dispatch(optimimisticForceTrialEndedAction());
	}
}
